import type { WindowKey } from "owa-bizchat-types";
import { getTimestamp, now } from "owa-datetime";

const visitStartedAtByWindow: Map<WindowKey, number> = new Map<WindowKey, number>();

export function markTasksHubShown(windowKey: WindowKey): void {
    visitStartedAtByWindow.set(windowKey, getTimestamp(now()));
}

export function consumeTimeInHubMs(windowKey: WindowKey): number | undefined {
    const startedAt = visitStartedAtByWindow.get(windowKey);
    visitStartedAtByWindow.delete(windowKey);
    
    return startedAt === undefined ? undefined : Math.max(0, getTimestamp(now()) - startedAt);
}
